/**
 * Game status constants and type definition.
 * These constants represent the different states a game can be in.
 */

export const CREATED = "CREATED" as const
export const WAITING = "WAITING" as const
export const PLAYING = "PLAYING" as const
export const ENDING = "ENDING" as const

/**
 * Union type representing all possible game statuses.
 */
export type GameStatus =
  | typeof CREATED
  | typeof WAITING
  | typeof PLAYING
  | typeof ENDING
